import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ChatComponent } from './chat/chat.component';
import { AuthGuard } from '../core/guards/auth.guard';

const routes: Routes = [
    {
        path: '', component: DashboardComponent, canActivate: [AuthGuard],
    },
    { path: 'calendar', component: CalendarComponent },
    { path: 'chat', component: ChatComponent },
    { path: 'email', loadChildren: () => import('./email/email.module').then(m => m.EmailModule) },
    { path: 'pages', loadChildren: () => import('./utility/utility.module').then(m => m.UtilityModule) },
    { path: 'charts', loadChildren: () => import('./chart/chart.module').then(m => m.ChartModule) },
    { path: 'maps', loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule) },
    { path: 'users', loadChildren: () => import('./user/user.module').then(m => m.UserModule), canActivate: [AuthGuard], },
    { path: 'homeBanner', loadChildren: () => import('./web-home/web-home.module').then(m => m.WebHomeModule) },
    { path: 'internship', loadChildren: () => import('./internship/internship.module').then(m => m.InternshipModule) },
    { path: 'applications', loadChildren: () => import('./internship-applications/internship-applications.module').then(m => m.InternshipApplicationsModule) },
    { path: 'courses', loadChildren: () => import('./courses/courses.module').then(m => m.CoursesModule) },
    { path: 'enrollments', loadChildren: () => import('./enrollment/enrollment.module').then(m => m.EnrollmentModule) },

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRoutingModule { }
